// KL - aircond gas top up.
const content = {
    slug: 'aircond-gas-top-up',
    title: (c) => `Aircond Gas Top Up KL from ${c.money(c.tables.gas.R410A.half)} | R32, R410A, R22`,
    description: (c) =>
        `Aircond gas top up in KL: R32 ${c.money(c.tables.gas.R32.half)}, R410A ${c.money(c.tables.gas.R410A.half)}, R22 ${c.money(c.tables.gas.R22.half)} per outdoor unit, after a pressure check.`,
    eyebrow: 'KL · Gas top up',
    h1: 'Aircond Gas Top Up in KL',
    lead: (c) =>
        `Gas only runs low when there is a leak - so we measure first, find the cause, and then top up at a fixed price per outdoor unit. R32 top up ${c.money(c.tables.gas.R32.half)}.`,
    image: 'blog/living/aircon-gas.jpg',
    imageAlt: 'Technician checking aircond gas pressure with gauges',
    facts: ['Pressure check first', 'R32, R410A, R22', 'Per outdoor unit'],
    priceTitle: 'Gas top up prices',
    priceIntro: 'Check the label on the outdoor unit for the gas type. Newer inverter units in Malaysia mostly use R32.',
    panel: { type: 'gas' },
    sections: [
        {
            title: 'Signs your aircond is low on gas',
            items: [
                'Air from the unit is cool but not cold, even after a service.',
                'Ice or frost on the copper pipe or the outdoor unit valves.',
                'The outdoor unit runs for very long stretches without stopping.',
                'A hissing sound from the pipes.',
            ],
        },
        {
            title: 'Which gas does your unit use?',
            tone: 'muted',
            cards: [
                { title: 'R32', body: 'Used in most new inverter units sold in Malaysia. More efficient, and the most common gas we top up today.' },
                { title: 'R410A', body: 'Common in units from roughly the last ten to fifteen years, inverter and non-inverter.' },
                { title: 'R22', body: 'Older non-inverter units. Being phased out; costlier to top up and worth comparing against a new unit.' },
            ],
        },
        {
            title: 'Top up or fix the leak?',
            paragraphs: [
                'If your aircond needs gas every few months, the gas is escaping - often at the flare joints where pipes connect, especially on units that were moved during renovation, or on old outdoor units exposed to rain and sun on condo ledges. The technician checks the joints and quotes the repair separately, so you can fix it once instead of paying for top ups again and again.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is aircond gas top up in KL?',
            answer: (c) => `${c.money(c.tables.gas.R32.half)} for R32, ${c.money(c.tables.gas.R410A.half)} for R410A and ${c.money(c.tables.gas.R22.half)} for R22, per outdoor unit. A full refill after a leak repair costs ${c.money(c.tables.gas.R32.full)} for R32.`,
        },
        {
            question: 'Does my aircond need a gas top up every service?',
            answer: 'No. A healthy, sealed system keeps its gas for years. Be wary of a "gas top up" added to every service by default.',
        },
        {
            question: 'Can you top up gas during a chemical wash?',
            answer: 'Yes - book both together if the unit is cooling poorly. The technician checks the pressure after cleaning and tops up only if needed.',
        },
    ],
    schema: {
        name: 'Aircond Gas Top Up in Kuala Lumpur',
        serviceType: 'Air conditioner refrigerant recharge',
        offers: (c) => [
            { name: 'R32 gas top up, 1 outdoor unit', price: c.tables.gas.R32.half },
            { name: 'R410A gas top up, 1 outdoor unit', price: c.tables.gas.R410A.half },
            { name: 'R22 gas top up, 1 outdoor unit', price: c.tables.gas.R22.half },
            { name: 'R32 full refill, 1 outdoor unit', price: c.tables.gas.R32.full },
        ],
    },
}

export default content
